(function () {
  angular.module('binky.core.dom-utils', []);
})();
